import { render, staticRenderFns } from "./add-save-on-key.vue?vue&type=template&id=50fd547a&lang=html&"
import script from "./add-save-on-key.vue?vue&type=script&lang=js&"
export * from "./add-save-on-key.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "add-save-on-key.vue"
export default component.exports